import { render, staticRenderFns } from "./RecebimentoFiltro.vue?vue&type=template&id=0b7dd08e&scoped=true"
import script from "./RecebimentoFiltro.vue?vue&type=script&lang=ts"
export * from "./RecebimentoFiltro.vue?vue&type=script&lang=ts"
import style0 from "./RecebimentoFiltro.vue?vue&type=style&index=0&id=0b7dd08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7dd08e",
  null
  
)

export default component.exports